import { render, staticRenderFns } from "./TicketLogs.vue?vue&type=template&id=5a676f8e&"
import script from "./TicketLogs.vue?vue&type=script&lang=ts&"
export * from "./TicketLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports